import library from './library'

export default (tokenStorage, userStorage, tokenTiming, companyStorage, environment, client, libraryServicesApi) =>
    (apiInstance, oauthInstance) => {
        const service = {}
        const {
            login,
            loginWithCognito,
            logout,
            refreshAccessTokenWhenIsToStayConnected,
            refreshAccessTokenOnTimeout,
            forgotPassword,
            resetPasswordFind,
            resetPassword,
        } = library(
            tokenStorage,
            userStorage,
            tokenTiming,
            companyStorage,
            environment,
            apiInstance,
            oauthInstance,
            libraryServicesApi
        )

        service.loginWithCognito = (token) => {
            const { clientId, clientSecret } = client
            return loginWithCognito(token, clientId, clientSecret)
        }

        service.logout = () => {
            return logout()
        }

        service.refreshAccessToken = () => {
            return refreshAccessTokenWhenIsToStayConnected()
        }

        service.refreshAccessTokenOnTimeout = () => {
            return refreshAccessTokenOnTimeout()
        }

        service.login = (username, password, keepMeLoggedIn, cpf) => {
            const { clientId, clientSecret } = client
            return login(clientId, clientSecret)(username, password, keepMeLoggedIn, cpf)
        }

        service.forgotPassword = (username, captcha, locale, cpf) => {
            return forgotPassword(username, captcha, locale, cpf)
        }

        service.resetPasswordFind = (token) => {
            return resetPasswordFind(token)
        }

        service.resetPassword = (token, email, password) => {
            return resetPassword(token, email, password)
        }

        return service
    }
